export default "__VITE_ASSET__CgODqncH__"